import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { postItemBookmark } from '../../../api/items';

import { generateItemCIDKey } from '../../../components/Items/utils/generateItemCIDKey';
import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';
import { mergeItemWithUserData } from '../../../utils/items';

import { REQUEST } from '../../../constants/request';

export const addItemBookmark = createAsyncThunk(
  'items/addItemBookmark',
  async ({ path, params }, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const [itemResponse, itemUserDataResponse] = await postItemBookmark(
        { path, params },
        {
          cancelToken: source.token,
        },
      );
      return mergeItemWithUserData(itemResponse, itemUserDataResponse);
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition: ({ orgId, streamId, channelId, streamItemId }, { getState }) => {
      const itemCIDKey = generateItemCIDKey({
        orgId,
        streamId,
        channelId,
        streamItemId,
      });
      const itemsStore = getState().items;

      return (
        itemsStore.items.item.actions.bookmark.request[itemCIDKey]?.loading !==
        REQUEST.pending
      );
    },
  },
);

export const addItemBookmarkExtraReducers = builder => {
  builder
    .addCase(addItemBookmark.pending, (state, action) => {
      const itemCIDKey = generateItemCIDKey(action.meta.arg.path);
      checkAndSetLoadingWithId(
        state.items.item.actions.bookmark.request,
        action,
        itemCIDKey,
      );
    })
    .addCase(addItemBookmark.fulfilled, (state, action) => {
      const itemCIDKey = generateItemCIDKey(action.meta.arg.path);
      onMatchedRequest(
        state.items.item.actions.bookmark.request[itemCIDKey],
        action,
        () => {
          state.items.item.byId[itemCIDKey] = action.payload;
          if (!state.items.item.allIds.includes(itemCIDKey)) {
            state.items.item.allIds.push(itemCIDKey);
          }
        },
      );
    })
    .addCase(addItemBookmark.rejected, (state, action) => {
      handleRequestRejection(
        state.items.item.actions.bookmark.request[
          generateItemCIDKey(action.meta.arg.path)
        ],
        action,
      );
    });
};
